/** Shared character size — visual target and collision capsule stay in sync. */
export const CHARACTER_HEIGHT = 1.55;
/** Slimmer than old 0.28 so Mixamo torsos don't snag on doorjambs / debris. */
export const CHARACTER_RADIUS = 0.2;
/** Collision body starts slightly above soles to reduce curb snags. */
export const CHARACTER_FEET_CLEARANCE = 0.04;
